export default "__VITE_ASSET__ExXMsZiHL1iQ$rmVWlXjOg__";